import request from '@/utils/request'

let Labor_protectionApi = {

  /*劳保列表*/
  list(data) {
    return request._post('/shop/plus.labor_protection.Index/index', data);
},
/*添加劳保*/
add(data) {
    return request._post('/shop/plus.labor_protection.Index/add', data);
},
/*修改劳保*/
edit(data) {
    return request._post('/shop/plus.labor_protection.Index/edit', data);
},
/*删除劳保*/
del(data) {
    return request._post('/shop/plus.labor_protection.Index/del', data);
},
/*劳保详情*/
detail(data) {
  return request._post('/shop/plus.labor_protection.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.labor_protection.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.labor_protection.Setting/getSetting', data, errorback);
    },
}
export default Labor_protectionApi;



// WEBPACK FOOTER //
// ./src/api/labor_protection.js